import {useCallback} from 'react';

import type {User} from 'nutshell-core/users/users-types';

import type {NutFileInput, WidgetFragment as Widget} from 'nutshell-graphql-types';

import {AttachmentsWidget} from '../../../../../core-entity/widgets/attachments-widget/components/attachments-widget';

import {useAddAttachmentToAccount} from '../graphql/hooks/use-add-attachment-to-account';
import {useGetAttachmentsForAccount} from '../graphql/hooks/use-get-attachments-for-account';
import {useRemoveAttachmentFromAccount} from '../graphql/hooks/use-remove-attachment-from-account';

interface Props {
    accountId: string;
    user: User | null | undefined;
    widget: Widget;
}

export function AccountAttachmentsWidget(props: Props) {
    const {accountId, user, widget} = props;

    const {files, isLoading: isLoadingGetAttachments} = useGetAttachmentsForAccount(accountId);
    const {addAttachmentToAccount} = useAddAttachmentToAccount();
    const {removeAttachmentFromAccount} = useRemoveAttachmentFromAccount();

    const handleRemoveAttachment = useCallback(
        (fileId: string) => removeAttachmentFromAccount({account: accountId, fileId}),
        [accountId, removeAttachmentFromAccount]
    );

    const handleAddAttachment = useCallback(
        (filesToAdd: NutFileInput[]) =>
            addAttachmentToAccount({account: accountId, files: filesToAdd}, user, files),
        [addAttachmentToAccount, files, accountId, user]
    );

    return (
        <AttachmentsWidget
            user={user}
            entityId={accountId}
            widget={widget}
            files={files}
            isLoadingAttachments={isLoadingGetAttachments}
            onRemoveAttachment={handleRemoveAttachment}
            onAddAttachment={handleAddAttachment}
        />
    );
}
